import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { ActivityViewHelperService } from './../../services/activity-view-helper.service';
import { LoaderService } from '../../../app/services/loader.service';
declare var $: any;

@Component({
    selector: 'save-alert',
    styleUrls: ['./save-alert.style.scss'],
    templateUrl: './save-alert.template.html',
    standalone: false
})
export class SaveAlert implements  AfterViewInit {
  @ViewChild('closeAlertModalBtn') closeAlertModalBtn: ElementRef;
  private lastActiveElement: HTMLElement | null = null;

  constructor(
    private activityViewHelperService : ActivityViewHelperService,
    private loaderService : LoaderService
  ) {}

  ngAfterViewInit() {
    $('#saveAlertModal').on('show.bs.modal', () => {
      this.lastActiveElement = <HTMLElement>document.activeElement;
    });

    $('#saveAlertModal').on('shown.bs.modal', () => {
      this.closeAlertModalBtn.nativeElement.focus();
      this.closeAlertModalBtn.nativeElement.classList.add('focus-visible');
    });

    $('#saveAlertModal').on('hidden.bs.modal', () => {
      this.lastActiveElement?.focus();
    });
  }

  saveAlertActionSelection(val: boolean) {
    if(!val) { //Save the recording
      this.loaderService.hideLoader();
    }
    this.activityViewHelperService.saveAlertAction.next(val);
  }
}